import type { TransactionSummaryModel } from "@/features/collections/api/models/TransactionSummaryModel";
import type { TransactionSummariesSortOrder } from "@/features/collections/TransactionSummariesSortOrder";
import { useHTTP, type PaginatedResponseModel } from "@/lib/http";
import { useHTTPQueryWithCursor } from "@/lib/http/useHTTPQueryWithCursor";

export const useTransactionSummaries = (collectionId: string, sortOrder: TransactionSummariesSortOrder, searchQuery: string) => {
	const http = useHTTP("Required");
	return useHTTPQueryWithCursor({
		queryKey: ["transactionSummaries", collectionId, sortOrder, searchQuery],
		queryFn: ({ pageParam = 0 }) => {
			return http<PaginatedResponseModel<TransactionSummaryModel>>({
				method: "GET",
				url: `/collection/${collectionId}/transaction-summary?cursor=${pageParam}&sort=${sortOrder}` + (searchQuery.trim() ? `&searchQuery=${encodeURIComponent(searchQuery)}` : "")
			});
		}
	});
};
